module.exports = __webpack_public_path__ + "img/11_2023_01_18.81392e8d.png";